import React, { useState, useEffect } from "react";
import { useTheme } from '@repo/shared';
import { useParams } from "react-router-dom";
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import AttendanceDataService from "../../services/event/EventAttendanceService";
import EventDataService from "../../services/event/EventService";
import LessonDataService from "../../services/class/LessonService";
import StudentDataService from "../../services/student/StudentService";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import "react-datepicker/dist/react-datepicker.css";

import 'react-tabs/style/react-tabs.css';

const Lesson = props => {
  const { appTheme } = useTheme();
  const { id } = useParams();
  const initialAttendanceState = AttendanceDataService.initialiseNewAttendance();
  const [currentAttendances, setCurrentAttendances] = useState(initialAttendanceState);
  const [students, setStudents] = useState([]);
  const [currentEvent, setCurrentEvent] = useState({});
  const [lesson, setLesson] = useState({});
  const [attendanceGrid, setAttendanceGrid] = useState([]);
  const [dateHeader, setDateHeader] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = `${appTheme?.appName} - Lesson`;
    fetchData(id);
  }, [id]);

  const fetchData = async (lessonId) => {
    try {
      const incomingLesson = await LessonDataService.getLesson(lessonId, 'event');
      setLesson(incomingLesson);

      console.log('about to call event.get');
      const event = await EventDataService.get(incomingLesson.eventId);
      setCurrentEvent(event);

      event.dates
        .sort((a, b) => moment(a).diff(moment(b)))
        .forEach((d, index) => {
          if (d.getTime() === new Date(incomingLesson.eventDate).getTime()) {
            incomingLesson.number = index + 1;
          }
        });


      const incomingDateHeader = { title: moment(incomingLesson.eventDate).format('DD MMM'), date: new Date(incomingLesson.eventDate), editable: true, editing: false }
      setDateHeader(incomingDateHeader);

      const attendances = await AttendanceDataService.getForEvent(event.id, incomingLesson.eventDate);
      console.log(attendances);
      setCurrentAttendances(attendances);

      const studentsForEvent = await StudentDataService.getAllForEvent(event.id);
      const attendanceGrid = generateAttendanceGrid({ attendances, dates: event.dates, studentsForEvent });

      setAttendanceGrid(attendanceGrid);
      setStudents(studentsForEvent);
    } catch (error) {
      console.error('Error fetching lesson data:', error);
    } finally {
      setLoading(false);
    }
  };

  const generateAttendanceGrid = ({ attendances, dates, studentsForEvent }) => {
    //might not need this

    //columns headers = dates
    //row headers = students
    //cells = attendences[date][student] || empty
    const grid = {};
    studentsForEvent.forEach(student => {
      const studentRow = {};
      grid[student.id] = studentRow;
      dates.forEach(date => {
        studentRow[date.getTime()] = {};

        //Here we need to lookup in attendances to see if we have an entry
        const found = attendances.find(attendance => attendance.studentId === student.id && attendance.eventDate.getTime() === date.getTime());
        studentRow[date.getTime()].attendance = found ? found.attendance : '';
      });
    });

    return grid;
  };

  const saveLesson = async () => {
    const savedLesson = await LessonDataService.saveLesson(lesson.id, lesson);
    alert('Lesson saved');
  }

  const toggleAttendance = (cell) => {
    if (cell.attendance === 'Y') {
      cell.attendance = 'N';
    } else if (cell.attendance === 'N') {
      cell.attendance = 'E';
    } else {
      cell.attendance = 'Y'
    }
    setAttendanceGrid({ ...attendanceGrid });
  }

  const renderStudentAttendance = student => {
    const renderAttendanceField = () => {
      const attendanceDate = dateHeader.date;
      const studentRow = attendanceGrid[student.id];
      const cell = studentRow[attendanceDate.getTime()];

      const styleClass = cell?.attendance === 'Y' ? 'attendanceCheckBoxY' : cell?.attendance === 'E' ? 'attendanceCheckBoxE' : 'attendanceCheckBoxN';
      if (dateHeader?.editing) {
        return <td className={styleClass} onClick={() => toggleAttendance(cell)}>{cell?.attendance ? cell?.attendance : ''}</td>
      } else {
        return <td className={'attendanceCheckBox'}>{cell?.attendance ? cell?.attendance : ''}</td>
      }
    }

    return (
      <tr>
        <td className="attendanceNameColumn">
          <div>
            <div>
              <span className='majorText'>{student.firstName} {student.lastName}</span>
            </div>
            <div>
              <span className='minorText'>{student.year} {student.className}</span>
            </div>
            <div>
              <span className='minorText'>{student.notes}</span>
            </div>
          </div>
        </td>
        {renderAttendanceField()}
      </tr>
    )
  };

  const toggleEditRegister = (dateHeader) => {

    if (dateHeader.editing) {
      //currently editing, this will save
      confirmAlert({
        title: 'Attendance Complete',
        message: `Have you completed the register for ${dateHeader.title}?`,
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              //save attendence for this date

              const attendances = { eventDate: dateHeader.date, studentRow: [] };

              students.forEach(student => {
                const attendanceGridStudentRow = attendanceGrid[student.id];
                attendances.studentRow.push({ studentEventId: student.studentEventId, attendance: attendanceGridStudentRow[dateHeader.date.getTime()].attendance ? attendanceGridStudentRow[dateHeader.date.getTime()].attendance : '' });
              });
              console.log('Persisting attendance for date', dateHeader.date, attendances);
              AttendanceDataService.update({ eventId: currentEvent.id, attendances });
              //then turn off editing
              dateHeader.editing = false;
              setDateHeader({ ...dateHeader });
            }
          },
          {
            label: 'No',
            onClick: () => { }
          },
          {
            label: 'Discard',
            onClick: () => fetchData(id)
          }
        ]
      });


    } else {
      dateHeader.editing = true;
      setDateHeader({ ...dateHeader });
    }
  }

  const renderBody = () => {
    return (
      <>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
            <div style={{ textAlign: 'center' }}>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p style={{ marginTop: '10px' }}>Loading lesson data...</p>
            </div>
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col-sm">
                <h2>{currentEvent.title}</h2>
                {currentEvent.location}
              </div>
              <div className="col-sm">
              </div>
              <div className="col-sm">
                <h2>{currentEvent.teacher}</h2>
              </div>
            </div>
            <div className="row">

              <div className="form-group">
                <label htmlFor="notes">Event Notes</label>
                {currentEvent.notes
                  ? <div style={{ backgroundColor: '#eee', border: '1px solid black', maxHeight: 100, minHeight: 50, alignItems: 'center' }}>{currentEvent.notes}</div>
                  : <div style={{ color: 'gray', height: 30, borderColor: 'black', borderWidth: 1 }}>No notes</div>
                }
              </div>
            </div>

            <div style={{ margin: 5 }} />

            <div className="row">
              <Tabs>
                <TabList>
                  <Tab>Attendance</Tab>
                </TabList>

                <TabPanel>
                  <div className="col">
                    <table className="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <td></td>
                          {
                            [dateHeader].map(h => {
                              const attendanceHeaderStyle = h.editable ? (h.editing ? 'attendanceHeaderEditingOn' : 'attendanceHeaderEditingOff') : ''
                              const onHeaderClick = h.editable ? () => {
                                toggleEditRegister(h);
                              } : null;
                              return (
                                <td className={attendanceHeaderStyle} onClick={onHeaderClick}>
                                  <div>{h.title}</div>
                                </td>)
                            })
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {attendanceGrid && students.map(student => renderStudentAttendance(student))}
                      </tbody>
                    </table>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="col">
                    <div style={{ margin: 10 }}>
                      <div className="form-group">
                        <label htmlFor="notes">Lesson Notes</label>
                        <textarea
                          style={{ height: 100 }}
                          type="text"
                          className="form-control"
                          id="notes"
                          name="notes"
                          value={lesson.notes || ''}
                          onChange={event => setLesson({ ...lesson, notes: event.target.value })}
                        />
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={saveLesson}
                        >Save Lesson Notes</button>
                      </div>
                    </div>
                    <div style={{ margin: 5 }} />
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </>
        )}
      </>
    )
  }
  return (
    <Container className="py-2 py-lg-4">
      <Row className="justify-content-center">
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Header className="d-flex align-items-center gap-2">
              <h2 className="mb-0">Class Register</h2>
            </Card.Header>
            <Card.Body className="p-3" style={{ overflowX: 'auto' }}>
              {renderBody()}
            </Card.Body>
            <Card.Footer className="text-muted">

            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Lesson;